import type { TextBoxColors } from 'atoms/TextBox'
import type { IDropdownHeaderProps } from './DropdownHeader'

import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import {
  DropdownHeaderAlignItems,
  DropdownHeaderDirection,
  DropdownHeaderJustifyContent,
} from './DropdownHeader.h'

export const DropdownHeaderStyled = styled.div<
  Omit<IDropdownHeaderProps, 'color'> & { colorDefault?: TextBoxColors }
>`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  display: flex;
  flex-direction: ${({ direction }) =>
    direction || DropdownHeaderDirection.Row};
  justify-content: ${({ justifyContent }) =>
    justifyContent || DropdownHeaderJustifyContent.FlexStart};
  align-items: ${({ alignItems }) =>
    alignItems || DropdownHeaderAlignItems.FlexStart};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  color: ${({ colorDefault }) =>
    colorDefault ? `var(${colorDefault})` : 'inherit'};
  cursor: pointer;

  ${IconSC} {
    transform: ${({ isOpened }) => (isOpened ? 'rotate(180deg)' : 'initial')};
    transform-origin: center;
  }
`
